import React, {useEffect, useState} from 'react';
import { useSelector , useDispatch} from 'react-redux';
import {
  Grid, Button, Stack, Box, Tooltip, Link,
  Paper, Typography, IconButton
} from '@mui/material';


import {usePlayContext} from '../utils/PlayContext';

import {   selectVisitorById } from '../store/visitorSlice';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';


import GotoIcon from '@mui/icons-material/ArrowRight';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Tty';
import CompanyIcon from '@mui/icons-material/Business';
import HostIcon from '@mui/icons-material/Deck';

import LastInviteIcon from '@mui/icons-material/DateRange';
import LastVisitIcon from '@mui/icons-material/AvTimer';

import { useNavigate, useLocation, useParams } from 'react-router-dom';


import visitorService from '../services/visitorService'


import { LegendToggleRounded } from '@mui/icons-material';


import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

import EnrolIcon from '@mui/icons-material/Explore';
import CheckInIcon from '@mui/icons-material/Login';
import CheekOutIcon from '@mui/icons-material/Logout';

const VisitorHistoryItem = ({h})=>{

  /*
    	ENROL,
	  CHECK_IN,
	  CHECK_OUT,
  */


    let icon = null;
    let color = 'info'
  
    switch (h.action)
    {
        case 'ENROL':
          icon = <EnrolIcon/>
          color='#3333aa'
          break;
        case 'CHECK_IN':
            icon = <CheckInIcon/>
            color='#33aa33'
            break;
        case 'CHECK_OUT':
            icon = <CheekOutIcon/>
            color='#cc6666'
            break;      
    }
  

  return (
    <>
    <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar size='small'
            sx={{bgcolor:`${color}`}}
            alt={h.action} >
              {icon}
          </Avatar>
        </ListItemAvatar>
    <ListItemText
      primary={
          <Box sx={{display:'flex'}}>
            <Typography variant="subtitle2" >{h.action}</Typography>&nbsp; &nbsp;&nbsp; &nbsp;
            <Typography variant="body1">{h.actionTm}</Typography>
            </Box>
      }
      secondary={
        <React.Fragment>
          <Typography
            sx={{ display: 'inline' }}
            component="span"
            variant="body2"
            color="text.primary"
          >
            
          </Typography>
          {h.remarks}
        </React.Fragment>
      }
    />
  </ListItem>
  <Divider variant="inset" component="li" />
  </>

  )

}




const VisitorDetailPage = () => {

    const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
      setTenantLogo
    }=usePlayContext()

    const navigate = useNavigate()
    const {id}=useParams()
    const dispatch = useDispatch()
    const [photo, setPhoto] = useState(undefined)
    
    const [showHistories, setShowHistories] = useState(!false)
    
    const [histories, setHistories] = useState([])
    

    const visitor = useSelector(selectVisitorById(id))



    const downloadPhoto = async (id)=>
    {
        setStatus('processing')
        try
        {
          let response = await visitorService.fetchPhotoAndHistory(id)
          
          let xxx =response.data

          console.log("xxxxxxxxxxxxxx="+xxx)

          if (xxx && xxx.photo)
          {
            setPhoto("data:image/png;base64,"+xxx.photo)
          }

          setHistories(xxx.histories ? xxx.histories:[])

          
          
          setStatus('succeed')
        }
        catch (ex){
          setErrorMessage(ex.message)
          setStatus('error')
          console.error("xxx::"+ex.message);
    }
  
    }
    
    useEffect(() =>{
      setAppTitle( ['Visitor',visitor.name])
      setErrorMessage('')
      setErrorTitle('')
      downloadPhoto(id);

      }, [id])
  


    return (
    <Box sx={{ p:0, width:'100%' }}>
         
      <Paper sx={{border:'none', justifyContent: "flex-start", px: 1}} elevation={0} >
        
      <Box
        sx={{ display: {xs:'block',md:'block'}, p: 1, }} 
      >

          <Grid  container columns={18} spacing={1} sx={{px:1}}> 

                                   
                  <Grid item xs={18} md={9} lg={6} 
                      sx={{mx:0, borderBottom: 1, borderBottomColor:{xs:'#cccccc', md:'white'}}}>
                        
                          <Typography  variant="body1"  >

                              {/** <PersonIcon size='small' color="primary"  sx={{mr:1, }}/>*/}
                          <strong>Name:</strong>&nbsp;&nbsp;
                            {visitor.name}
                          </Typography>
                            
                  </Grid>
                  <Grid item xs={18} md={9} lg={6} 
                              sx={{mx:0, borderBottom: 1, borderBottomColor:{xs:'#cccccc', md:'white'}}}>
                          
                          
                          <Typography  variant="body1"  >
                            {/** <PhoneIcon size='small' color="primary"  sx={{mr:1, }}/> */}
                            <strong>Phone Number:</strong>&nbsp;&nbsp;
                            {visitor.phoneDisplay}
                          </Typography>
                          
                  </Grid>

                  <Grid item xs={18} md={9} lg={6} 
                      sx={{mx:0, borderBottom: 1, borderBottomColor:{xs:'#cccccc', md:'white'}}}>
                        
                            <Typography  variant="body1"  >
                            {/** <EmailIcon size='small' color="primary"  sx={{mr:1, }}/> */}
                            <strong>Email:</strong>&nbsp;&nbsp;
                              {visitor.email}
                            </Typography>
                        
                  </Grid>
                  <Grid item xs={18} md={9} lg={6} 
                      sx={{ mx:0, borderBottom: 1, borderBottomColor:{xs:'#cccccc', md:'white'}}}>
                        
                            <Typography  variant="body1"  >
                            {/** <CompanyIcon size='small' color="primary"  sx={{mr:1, }}/> */}
                            <strong>Organization:</strong>&nbsp;&nbsp;
                              {visitor.company}
                            </Typography>
                        
                    </Grid>
                    
                    <Grid item xs={18} md={9} lg={6} 
                      sx={{ mx:0, borderBottom: 1, borderBottomColor:{xs:'#cccccc', md:'white'}}}>
                        
                            <Typography  variant="body1"  >
                            {/** <HostIcon size='small' color="primary"  sx={{mr:1, }}/>*/}
                            <strong>Host:</strong>&nbsp;&nbsp;
                              {visitor.host}
                            </Typography>
                        
                    </Grid>

                    
                    

                    
                            
                </Grid>
              
            </Box>
            <Box sx={{pb:2,my:1,display:'flex', width:'100%', justifyContent: 'space-around'}}>

                    <Button variant="outlined" 
                        //variant="contained" 
                        color='success'  
                      onClick={()=>navigate("/visitor/edit/"+id)}
                    > Edit</Button>

                    <Button variant="outlined" 
                        //variant="contained"
                        color='success'  
                      onClick={()=>navigate("/invite_visitor/"+id)}
                    > Invite</Button>

                    <Button variant="outlined" 
                        //variant="contained" 
                        color='primary'   
                      //disabled = {status==='success'}
                      onClick={()=>navigate(-1)}
                    > Back</Button>

            </Box>
            
          { histories && 
          <Box sx={{ml:3, mr:1,p:0, mb:2, border:0, borderColor:'#DDDDDD'}}>
            { !showHistories &&
                            <Link  sx={{ ml:3}}
                          onClick={()=>setShowHistories(true)}
                > View Asscee Histories 
                  </Link>
              }
              { showHistories &&
                <List sx={{ width: '100%', maxWidth: 999, bgcolor: 'background.paper' }}
                    subheader={<Typography variant='subtitle1'>Access Histories</Typography>} 
                    dense
                    disablePadding
                >
                  {
                    histories.map(
                      hist=><VisitorHistoryItem key={hist.id} h={hist}/>)
                    
                    
                  }

                </List>
            }
        </Box>
        }
      </Paper>
      
      
    </Box>
  );
};

export default VisitorDetailPage;
